import React from "react";
import OptionalSegmentVisibility from "./OptionalSegmentVisibility";

const MappingExplorerTree = ({
  loops,
  selectedSegment,
  expandedLoops,
  onToggleLoop,
  onSelectSegment,
  onToggleSegmentVisibility,
}) => {
  return (
    <div className="explorer-tree">
      <div className="explorer-tree-header">
        <h2 className="explorer-tree-title">X12 278 Structure</h2>
        <p className="explorer-tree-subtitle">005010X217 · Health Care Services Review</p>
      </div>

      <div className="explorer-tree-body">
        {loops.map((loop) => {
          const isExpanded = expandedLoops.has(loop.loopId);
          const visibleOptional = loop.segments.filter(
            (s) => s.isOptional && s.isUserVisible
          ).length;
          const optionalCount = loop.segments.filter((s) => s.isOptional).length;

          return (
            <div key={loop.loopId} className="explorer-loop">
              <button
                type="button"
                className="explorer-loop-header"
                onClick={() => onToggleLoop(loop.loopId)}
                aria-expanded={isExpanded}
              >
                <span className={`explorer-chevron${isExpanded ? " open" : ""}`} />
                <span className="explorer-loop-label">{loop.displayName}</span>
                <span className="explorer-loop-meta">
                  {loop.segments.length} seg
                  {optionalCount > 0 && ` · ${visibleOptional}/${optionalCount} opt`}
                </span>
              </button>

              {isExpanded && (
                <ul className="explorer-segment-list">
                  {loop.segments.map((segment) => {
                    const isSelected =
                      selectedSegment?.segmentId === segment.segmentId;
                    return (
                      <li key={segment.segmentId}>
                        <div
                          className={`explorer-segment-row${
                            isSelected ? " selected" : ""
                          }${segment.isOptional ? " optional" : " required"}${
                            segment.isOptional && !segment.isUserVisible
                              ? " user-hidden"
                              : ""
                          }`}
                        >
                          <button
                            type="button"
                            className="explorer-segment-btn"
                            onClick={() =>
                              onSelectSegment({
                                ...segment,
                                loopId: loop.loopId,
                                loopName: loop.displayName,
                              })
                            }
                          >
                            <span className="explorer-segment-tag">{segment.tag}</span>
                            <span className="explorer-segment-info">
                              <span className="explorer-segment-name">
                                {segment.friendlyName ?? segment.segmentId}
                              </span>
                              <span className="explorer-segment-meta-row">
                                <span
                                  className={`explorer-usage-badge ${
                                    segment.isOptional ? "optional" : "required"
                                  }`}
                                >
                                  {segment.isOptional ? "Optional" : "Required"}
                                </span>
                                <span className="explorer-element-count">
                                  {segment.elements.length} elements
                                </span>
                              </span>
                            </span>
                          </button>
                          {segment.isOptional && onToggleSegmentVisibility && (
                            <OptionalSegmentVisibility
                              visible={segment.isUserVisible}
                              segmentId={segment.segmentId}
                              onChange={onToggleSegmentVisibility}
                            />
                          )}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MappingExplorerTree;
